import * as z from "zod";

export enum PoEmailFrequency {
  DAILY = "daily",
  WEEKLY = "weekly",
  BI_WEEKLY = "bi_weekly",
  MONTHLY = "monthly",
}

export enum DayOfWeek {
  SUNDAY = "sunday",
  MONDAY = "monday",
  TUESDAY = "tuesday",
  WEDNESDAY = "wednesday",
  THURSDAY = "thursday",
  FRIDAY = "friday",
  SATURDAY = "saturday",
}

const PoEmailSettingsSchema_ = z.object({
  id: z.coerce.string(),
  accountId: z.coerce.string(),
  enabled: z.boolean(),
  recipients: z.array(z.string()),
  frequency: z.nativeEnum(PoEmailFrequency),
  dayOfWeek: z.nativeEnum(DayOfWeek),
  lastSentAt: z.coerce.date().nullable(),
  nextRunAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const PoEmailSettingsSchema: z.ZodType<PoEmailSettings> =
  PoEmailSettingsSchema_;
export interface PoEmailSettings
  extends z.infer<typeof PoEmailSettingsSchema_> {}

export interface UpsertPoEmailSettingsInput {
  accountId: bigint;
  enabled: boolean;
  recipients: string[];
  frequency: PoEmailFrequency;
  dayOfWeek: DayOfWeek;
  nextRunAt: Date | null;
}
